// extracted by mini-css-extract-plugin
export var required = "_gb-0";